import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './footer.scss'

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <ul>
                    <li><a href="https://github.com/nokibrokes" target="_blank"><FontAwesomeIcon className="footer-icon" icon={['fab', 'github']} /></a></li>
                    <li><a href="https://www.linkedin.com/in/ariful-mowla/" target="_blank"><FontAwesomeIcon className="footer-icon" icon={['fab', 'linkedin']} /></a></li>
                    <li><a href="https://codepen.io/nokibrokes" target="_blank"><FontAwesomeIcon className="footer-icon" icon={['fab', 'codepen']} /></a></li>
                    <li><a href="https://facebook.com/nokibrokes" target="_blank"><FontAwesomeIcon className="footer-icon" icon={['fab', 'facebook']} /></a></li>
                    <li><a href="https://twitter.com/ArifulMowla" target="_blank"><FontAwesomeIcon className="footer-icon" icon={['fab', 'twitter']} /></a></li>
                </ul>
                <p className="text-center">&#169; Design & Developed by me </p>
            </div>
        </footer>
    );
};

export default Footer;